import { ThumbaCoin } from "@roman/shared/components/Icons";
import type { WebUser } from "@roman/shared/types/WebUser";
import { formatNumberWithCommas } from "@roman/shared/utils/formatNumberWithCommas";

export const PointsButton = ({
  user,
}: {
  user: WebUser;
}) => {
  const points = user.freePoints ? Number.parseInt(user.freePoints) : 0;
  const textSize =
    points >= 10000000 ? "text-xs md:text-base" : points >= 100000 ? "text-sm md:text-base" : "text-base";
  return (
    <div className="gap-[2px] h-[36px] md:h-[40px] px-2 bg-[#F3F4FF] hover:bg-[#F3F4FF]/70 font-bold flex justify-center items-center rounded-full border border-[#E7EBEE]">
      <ThumbaCoin className="h-[16px]" />
      <span className={`${textSize} text-black text-base font-semibold font-roboto`}>
        {formatNumberWithCommas(points.toString())}
      </span>
    </div>
  );
};
